import React from 'react';
import { Field } from 'formik';
import {
  citizenshipOptions,
  salutationOptions,
  nricColourOptions,
  genderOptions,
  raceOptions,
  yearOptions,
} from '../../store';

import Section from '../form/Section';
import Dropdown from '../form/Dropdown';
import DropdownWithChange from '../form/DropdownWithChange';
import TextInput from '../form/TextInput';
import Checkbox from '../form/Checkbox';
import AlumniCheckbox from '../form/AlumniCheckbox';
import Fieldset from '../form/Fieldset';
import TextArea from '../form/TextArea';
import RadioGroup from '../form/RadioGroup';
import DateField from '../form/DateField';

const PersonalInformation = ({ values, setFieldValue }) => {
  /**
   * citizenship handler
   * @param {*} e
   */
  const citizenshipHandler = (e) => {
    const val = e.target.value;

    if (val === 'Non-Singapore Citizen/PR') {
      setFieldValue('nric', '');
      setFieldValue('nric_colour', '');
      setFieldValue('employed', '');
    }

    setFieldValue('citizenship', val);
  };

  /**
   * alumni handler
   * @param {*} e
   */
  const alumniHandler = (e) => {
    const checked = e.target.checked;

    if (!checked) {
      setFieldValue('programme', '');
      setFieldValue('programme_year', '');
    }

    setFieldValue('alumni', checked);
  };

  return (
    <Section title='Personal Information'>
      <Field
        label='Citizenship'
        name='citizenship'
        options={citizenshipOptions}
        value={values.citizenship}
        required
        nodefault
        component={DropdownWithChange}
        change={citizenshipHandler}
      />
      <div className='flex flex-col md:flex-row mb-2 items-start md:items-center'>
        {values.citizenship === 'Singapore Citizen' && (
          <Field
            label='I would like to tap on SSG Funding'
            name='ssg_grant'
            value={values.ssg_grant}
            component={Checkbox}
            className='mr-10'
            tooltip='70% off course fees before GST'
          />
        )}
        {values.citizenship !== 'Non-Singapore Citizen/PR' && (
          <Field
            label='I am eligible for WTS'
            name='wts_eligibility'
            value={values.wts_eligibility}
            component={Checkbox}
            className='mr-10'
            tooltip='Workfare Training Support Scheme: To qualify, individuals must be a Singapore Citizen; and Aged 35 years and above (13 years and above for Persons With Disabilities); and  Earn a monthly income of not more than $2,000.'
          />
        )}
        <Field
          label='I am NUS Alumni'
          name='alumni'
          value={values.alumni}
          component={AlumniCheckbox}
          className='mr-10'
          change={alumniHandler}
        />
      </div>

      {values.alumni && (
        <Fieldset title='Alumni'>
          <div className='flex flex-col md:flex-row'>
            <div className='mr-0 md:mr-3 w-full md:w-1/2'>
              <Field
                label='Programme'
                name='programme'
                value={values.programme}
                required
                component={TextInput}
              />
            </div>
            <div className='ml-0 md:ml-3 w-full md:w-1/2'>
              <Field
                label='Year'
                name='programme_year'
                value={values.programme_year}
                required
                options={yearOptions}
                component={Dropdown}
              />
            </div>
          </div>
        </Fieldset>
      )}

      <div className='flex flex-col md:flex-row mb-2'>
        <div className='mr-0 md:mr-3 w-full md:w-1/2'>
          <Field
            label='Salutation'
            name='salutation'
            options={salutationOptions}
            value={values.salutation}
            required
            component={Dropdown}
          />
        </div>
        <div className='ml-0 md:ml-3 w-full md:w-1/2'>
          <Field
            label={
              values.citizenship === 'Non-Singapore Citizen/PR'
                ? 'Full Name'
                : 'Name as in NRIC'
            }
            name='name'
            placeholder='Name'
            value={values.name}
            component={TextInput}
            required
          />
        </div>
      </div>

      {values.citizenship !== 'Non-Singapore Citizen/PR' && (
        <Fieldset>
          <div className='flex flex-col md:flex-row'>
            <div className='mr-0 md:mr-3 w-full md:w-1/2'>
              <Field
                label='NRIC No'
                name='nric'
                value={values.citizenship}
                required
                component={TextInput}
              />
            </div>
            <div className='ml-0 md:ml-3 w-full md:w-1/2'>
              <Field
                label='NRIC Colour'
                name='nric_colour'
                value={values.nric_colour}
                options={nricColourOptions}
                required
                component={Dropdown}
              />
            </div>
          </div>
        </Fieldset>
      )}

      <Field
        label='Residential Address'
        name='home_address'
        value={values.home_address}
        required
        component={TextArea}
      />

      <div className='flex flex-col md:flex-row mb-2'>
        <div className='mr-0 md:mr-3 w-full md:w-1/2'>
          <Field
            label='Email'
            name='email'
            value={values.email}
            type='email'
            placeholder='example: email@address.com'
            required
            component={TextInput}
          />
        </div>
        <div className='ml-0 md:ml-3 w-full md:w-1/2'>
          <Field
            label='Mobile No'
            name='contact_no'
            value={values.contact_no}
            required
            component={TextInput}
          />
        </div>
      </div>
      <div className='flex flex-col w-full md:flex-row'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='Gender'
            name='gender'
            value={values.gender}
            required
            options={genderOptions}
            component={RadioGroup}
            change={(val) => setFieldValue('gender', val)}
          />
        </div>
        <div className='w-full ml-0 md:w-1/2 md:ml-3'>
          <Field
            label='Race'
            name='race'
            value={values.race}
            required
            options={raceOptions}
            component={Dropdown}
          />
        </div>
      </div>
      <div className='flex flex-col md:flex-row mb-2'>
        <div className='w-full mr-0 md:w-1/2 md:mr-3'>
          <Field
            label='Date of birth'
            name='date_of_birth'
            value={values.date_of_birth}
            required
            component={DateField}
            change={(val) => setFieldValue('date_of_birth', val)}
          />
        </div>
        <div className='w-full ml-0 md:w-1/2 md:ml-3'></div>
      </div>
      <div className='flex flex-col md:flex-row mb-2'>
        <div className='w-full md:w-1/2 mr-0 md:mr-3'>
          <Field
            label='Emergency Contact Name'
            name='emergency_contact_name'
            value={values.emergency_contact_name}
            component={TextInput}
          />
        </div>
        <div className='w-full ml-0 md:w-1/2 md:ml-3'>
          <Field
            label='Emergency Contact No.'
            name='emergency_contact_no'
            value={values.emergency_contact_no}
            component={TextInput}
          />
        </div>
      </div>
    </Section>
  );
};

export default PersonalInformation;
